import Axios from "axios";
import { toJS } from "mobx";
import React, { useEffect, useMemo, useRef, useState } from "react";
import EventLabel from "../../components/EventLabel";
import { VoucherLinkDialog } from "./components/VoucherLinkDialog";
import { VoucherRow } from "./components/VoucherRow";

export const VoucherModule = ({ orders, environment, badgeNo, settings, breakouts, voucherList = [], setVoucherList }) => {
  const { voucherType = [], showPriceSum, showAltName = false } = settings;
  const [usedVouchers, setUsedVouchers] = useState({});
  const [dialogVoucher, setDialogVoucher] = useState(null);
  const vouchers = useMemo(() => {
    if (voucherType.length > 0) {
      const vTypeIds = voucherType.map((vt) => vt.value);
      return voucherList.filter((v) => vTypeIds.includes(v.personTypeId));
    } else return voucherList;
  }, [voucherList, voucherType]);
  useEffect(() => {
    if (toJS(orders)[0]?.badgeNo) {
      updateVouchers(orders[0].badgeNo);
      getVoucherCount(orders[0].badgeNo);
    }
  }, [orders]);
  const updateVouchers = async (badgeNo) => {
    const { data } = await Axios.get(`./api/exhibitor/vouchers/${badgeNo}`);
    if (data.success && data.vouchers) {
      setVoucherList(data.vouchers);
    }
  };
  const getVoucherCount = async (badgeNo) => {
    const { data } = await Axios.get(`./api/exhibitor/vouchers/uses/${badgeNo}`);
    if (data.success) {
      setUsedVouchers(data.useCounts);
    }
  };
  const voucherTotalSum = useMemo(() => {
    let totalSum = 0;
    if (usedVouchers && vouchers) {
      for (const key in usedVouchers) {
        if (Object.hasOwnProperty.call(usedVouchers, key)) {
          const usedCount = usedVouchers[key];
          const voucher = vouchers.find((v) => v.exhibitorVoucherId == key);
          if (voucher) {
            const available = voucher.count;
            const bought = usedCount - available;
            const breakout = breakouts.find((b) => b.eventId == voucher.eventId);
            if (bought > 0) {
              const origAmount = breakout.eventId === 3656 && voucher.personTypeId === 2248 ? (breakout.amount ?? 0) - 4000 : breakout.amount ?? 0;
              const vatAmount = origAmount * 0.5 * (breakout.vatAmount && breakout.vatAmount > 0 ? breakout.vatAmount / 100 : 0);
              const singlePrice = breakout.eventId === 3629 || breakout.eventId == 3630 ?  origAmount + vatAmount :  (origAmount * 0.5) + vatAmount;
              totalSum += singlePrice * bought;
            }
          }
        }
      }
    }
    totalSum = totalSum.toFixed(2);
    return totalSum;
  }, [usedVouchers, vouchers]);
  const navigateToForm = (voucher) => {
    window.open(`./web/${voucher.contentLayoutCode}?exi=${voucher.exhibitorId}&pti=${voucher.personTypeId}`);
  };
  if (!vouchers || vouchers.length < 1)
    return (
      <div className="cms-voucher">
        <EventLabel name="NothingToShowMessage" groupName="CMS.Voucher" />
      </div>
    );
  return (
    <div className="cms-voucher">
      {voucherType.length > 0 ? <h2>{voucherType.map((vt) => vt.name).join(", ")}</h2> : null}
      <table>
        <thead>
          <tr>
            <th>
              <EventLabel name="NameHeader" groupName="CMS.Voucher" />{" "}
            </th>
            <th style={{ textAlign: "right" }}>
              <EventLabel name="UsedHeader" groupName="CMS.Voucher" />
            </th>
            <th style={{ textAlign: "right" }}>
              <EventLabel name="AvailableHeader" groupName="CMS.Voucher" />
            </th>
            <th style={{ textAlign: "right" }}>
              <EventLabel name="BoughtHeader" groupName="CMS.Voucher" />
            </th>
            {/* <th style={{ textAlign: "center" }}><EventLabel name="GetLinkHeader" groupName="CMS.Voucher" /></th> */}
            <th style={{ textAlign: "center" }}>
              <EventLabel name="OpenHeader" groupName="CMS.Voucher" />
            </th>
          </tr>
        </thead>
        <tbody>
          {vouchers.map((voucher, i) => {
            let breakout = breakouts.find((b) => b.eventId === voucher.eventId);
            return <VoucherRow key={i} {...{ breakout, voucher, navigateToForm, langCode: environment.lang, usedVouchers, showAltName }} />;
          })}
        </tbody>
        {showPriceSum ? (
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td style={{ textAlign: "right" }}>
                <EventLabel name="TotalSum" groupName="CMS.Voucher" />
              </td>
              <td style={{ textAlign: "right" }}>
                {voucherTotalSum} {environment.currency}
              </td>
              {/* <td>
              </td> */}
              <td></td>
            </tr>
          </tfoot>
        ) : null}
      </table>
      {dialogVoucher ? <VoucherLinkDialog onClose={() => setDialogVoucher(null)} {...dialogVoucher} /> : null}
    </div>
  );
};
